const viewed = new Set()

// FNV-1a: stable 32-bit hash, so a visitor keeps the same variant.
const hash = (text) => {
  let h = 2166136261
  for (let i = 0; i < text.length; i++) {
    h = Math.imul(h ^ text.charCodeAt(i), 16777619)
  }
  return h >>> 0
}

// Bools stay bools; variant weights ({ control: 50, big_image: 50 }) become one variant name.
export const resolveFlags = (config, visitorId) => Object.fromEntries(
  Object.entries(config).map(([name, value]) => {
    if (!value || typeof value !== 'object') return [name, value === true]

    const variants = Object.entries(value)
    const total = variants.reduce((sum, [, weight]) => sum + weight, 0)
    let point = (hash(`${name}:${visitorId}`) % 10000) / 10000 * total
    const picked = variants.find(([, weight]) => (point -= weight) < 0) || variants.at(-1)
    return [name, picked ? picked[0] : false]
  })
)

export const useFeatureFlags = () => useState('featureFlags', () => ({}))

// Returns true/false, or the variant name for A/B flags.
export const useFeatureFlag = (name) => {
  const value = useFeatureFlags().value[name] ?? false

  if (import.meta.client && typeof value === 'string' && !viewed.has(name)) {
    viewed.add(name)
    window.dataLayer.push({ event: 'experiment_viewed', experiment: name, variant: value })
  }
  return value
}
